module.exports = __webpack_public_path__ + "static/img/qq.fe820a6e.png";